import { Alert, Button } from 'framework/ui/mui-builder';

interface LoadErrorProps {
  message?: string;
  retry?: () => void | Promise<unknown>;
  loading?: boolean;
}

const LoadError = ({ message = 'Could not load data.', retry, loading }: LoadErrorProps) => (
  <Alert
    severity="error"
    action={
      retry && (
        <Button variant="outlined" size="small" color="error" disabled={loading} onClick={() => void retry()}>
          Retry
        </Button>
      )
    }
  >
    {message}
  </Alert>
);

export default LoadError;
